import { Archive, Edit, Trash2 } from 'lucide-react'
import type { ReactNode } from 'react'

import {
  ContextMenu,
  ContextMenuContent,
  ContextMenuItem,
  ContextMenuSeparator,
  ContextMenuTrigger,
} from '@/components/ui'
import type { CellContext } from '@/components/ui/table/types'
import { getDialogActions } from '@/stores/dialog'
import type { Folder } from '../../stores/types'
import { DeleteFolderDialog } from '../dialogs/DeleteFolderDialog'
import { RenameFolderDialog } from '../dialogs/RenameFolderDialog'
import { archiveFolder } from './archiveFolder'

export const ContextMenuCell = <T extends string | number>(
  Cell?: (cell: CellContext<Folder, T>) => ReactNode,
) => {
  return (cell: CellContext<Folder, T>) => {
    const { openDialog } = getDialogActions()
    const folder = cell.row.original as Folder
    const value = Cell ? Cell(cell) : cell.getValue()

    return (
      <ContextMenu>
        <ContextMenuTrigger asChild>
          <div className="h-full w-full flex items-center cursor-context-menu">
            {value}
          </div>
        </ContextMenuTrigger>
        <ContextMenuContent>
          <ContextMenuItem
            onClick={() => openDialog(RenameFolderDialog.id, folder)}
          >
            <Edit className="size-4" />
            Rename folder
          </ContextMenuItem>
          {folder.kind === 'project' && (
            <ContextMenuItem onClick={() => archiveFolder(folder)}>
              <Archive className="size-4" />
              Archive folder
            </ContextMenuItem>
          )}
          <ContextMenuSeparator />
          <ContextMenuItem
            onClick={() => openDialog(DeleteFolderDialog.id, folder)}
            destructive
          >
            <Trash2 className="size-4" />
            Delete folder
          </ContextMenuItem>
        </ContextMenuContent>
      </ContextMenu>
    )
  }
}
